import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["source", "template"]
    static values = { singular: { type: String, default: "record" }, plural: { type: String, default: "records" } }

    open(event) {
        event.preventDefault()
        const bulkElement = this.element.closest('[data-controller~="bulk"]')
        const bulk = this.application.getControllerForElementAndIdentifier(bulkElement, "bulk")
        if (!bulk || bulk.pending) return
        const ids = bulk.selectedIds()
        const destination = document.getElementById("remote_modal")
        if (!ids.length || !destination) return

        const content = this.templateTarget.content.cloneNode(true)
        const modalFrame = content.querySelector("turbo-frame")
        const form = content.querySelector("form")
        const source = new FormData(this.sourceTarget)
        ids.forEach(id => {
            this.addField(form, "ids[]", id)
            this.addField(form, `revisions[${id}]`, source.get(`revisions[${id}]`) || "")
        })
        content.querySelector("[data-assignment-count]").textContent =
            `${ids.length} ${ids.length === 1 ? this.singularValue : this.pluralValue} selected`
        const station = content.querySelector("[data-assignment-station]")
        if (station) {
            const packingJobs = bulk.availableCheckboxTargets.filter(checkbox =>
                checkbox.checked && checkbox.dataset.bulkAssignmentKind === "pack")
            const packing = packingJobs.length > 0
            const locations = new Set(packingJobs.map(checkbox => checkbox.dataset.bulkAssignmentLocation))
            station.hidden = !packing
            const input = station.querySelector("select")
            Array.from(input.options).forEach(option => {
                if (option.value && (locations.size !== 1 || !locations.has(option.dataset.locationId))) option.remove()
            })
            input.disabled = !packing
            input.required = packing
            const unavailable = station.querySelector("[data-assignment-station-unavailable]")
            unavailable.hidden = !packing || input.options.length > 1
            unavailable.textContent = locations.size > 1
                ? "Select packing tasks from one warehouse at a time."
                : "No active packing stations in this warehouse. Ask a warehouse manager to add one in Warehouse team settings."
        }
        destination.replaceChildren(...modalFrame.childNodes)
    }

    addField(form, name, value) {
        const input = document.createElement("input")
        input.type = "hidden"
        input.name = name
        input.value = value
        form.appendChild(input)
    }
}
